import React, { useState, useEffect } from 'react'
import { GridView } from '@planningcenter/tapestry-react'
import useWindowWidth from '../utils/useWindowWidth'
import { colors, breakpoints } from '../theme'

export const MenuContext = React.createContext()
export const ActivePathContext = React.createContext()

const GlobalLayout = ({ children }) => {
  const windowWidth = useWindowWidth()
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [activeOverviewPath, setActiveOverviewPath] = useState('')
  const [activeReferencePath, setActiveReferencePath] = useState('')

  useEffect(() => {
    if (windowWidth < breakpoints.lg) {
      setMobileMenuOpen(false)
    } else {
      setMobileMenuOpen(true)
    }
  }, [windowWidth])

  return (
    <ActivePathContext.Provider
      value={{
        activeOverviewPath,
        setActiveOverviewPath,
        activeReferencePath,
        setActiveReferencePath,
      }}
    >
      <MenuContext.Provider value={{ mobileMenuOpen, setMobileMenuOpen }}>
        <GridView
          height="100vh"
          maxHeight="100vh"
          width="100vw"
          maxWidth="1600px"
          margin="0 auto"
          columns="1fr"
          rows="auto 1fr"
          style={{ boxShadow: `0 0 15px ${colors['grey-5']}` }}
          mediaQueries={{
            lg: {
              columns: '1fr 4fr',
              rows: '100px 1fr',
            },
          }}
        >
          {children}
        </GridView>
      </MenuContext.Provider>
    </ActivePathContext.Provider>
  )
}

export default GlobalLayout
